<div class="container ready-for-tablet">
    <div class="row" style="padding: 1em">
        <div
            class="col-md-8 col-sm-12 offset-md-2 offset-sm-0 text-center mb-10"
        >
            <div id="has-driver-log-note-complete" class="text-center">
                <img
                    src="/assets/images/mailing-issue-banner.png"
                    alt="Mailing Issue Header"
                    class="mt-3"
                    style="max-width: 100%"
                />
            </div>

            <div class="delivery-header">
                <h1 class="mt-4 bold">Delivery Issue</h1>
                <p class="mt-3 description">
                    It looks like we may have the wrong address for you on file.
                </p>
                <img
                    src="/assets/images/mailing-issue-graphic.png"
                    alt="Mailing Issue Graphic"
                    class="mt-4"
                    style="max-width: 100%"
                />
                <p class="mt-4 description-grey">
                    Please visit playoctopus.com/help or call Octopus at (240)
                    366-5877 (Monday - Friday) to update your address.
                </p>
            </div>
            <hr class="mt-4" style="border-top: 2px solid #cccccc" />
            <div class="delivery-header">
                <h2 class="mt-4 bold">Delivery Details</h2>
                <p class="mt-4 description-grey">Shipping Address</p>
                <p class="mt-2 description">{{ address }}</p>

                <!-- <h3 class="mt-5 bold">Start earning now!</h3>
                <p class="mt-4 description">
                    Earn $25 every time a driver you refer starts driving with
                    the tablet. Share your personal referral code
                    <span class="bold">{{ referral_code }}</span> or your
                    personal link:
                    <a href="{{ referral_link }}" id="mailing-issue-referral-link">{{ referral_link }}</a> today!
                </p> -->
                <span class="mt-4 mb-5"
                    >Questions?
                    <a
                        class="link"
                        target="_blank"
                        id="mailing-issue-help-link"
                        href="https://playoctopus.com/help"
                        >playoctopus.com/help</a
                    ></span
                >
            </div>
        </div>
    </div>
</div>
